import { SearchContactsResponseDTO } from "../../api/types/apiResponse";

/**
 * Projette la réponse de recherche hybride de contacts (GET v1/contacts/search) en une liste
 * d'emails, en préservant l'ordre serveur (déjà trié par pertinence décroissante — NE PAS re-trier).
 *
 * Règles :
 *  - itère `dto.results` dans l'ordre serveur (aucun tri) ;
 *  - projette `contactEmail` en minuscules ;
 *  - si `opts.minScore` est fourni, ne garde que les contacts dont `score >= minScore` (ordre conservé) ;
 *  - déduplique via Set (première occurrence gardée) ;
 *  - `dto` / `results` absent ou vide → `[]`.
 *
 * @param dto  - Enveloppe de réponse `{ query, results, total }` (peut être partielle/vide).
 * @param opts - `minScore` optionnel : seuil de pertinence dans [0, 1].
 */
export function contactSearchResultsToEmails(
    dto: SearchContactsResponseDTO,
    opts?: { minScore?: number },
): string[] {
    const results = dto?.results;
    if (!results || results.length === 0) {
        return [];
    }

    const minScore = opts?.minScore;
    const emails: string[] = [];
    const seenEmails = new Set<string>();

    for (const contact of results) {
        // Seuil de pertinence optionnel : on écarte les contacts sous le seuil (ordre conservé).
        if (minScore !== undefined && contact.score < minScore) {
            continue;
        }

        const contactEmail = contact.contactEmail.toLowerCase();

        // Dédup : on ne garde que la première occurrence de chaque email.
        if (seenEmails.has(contactEmail)) {
            continue;
        }

        seenEmails.add(contactEmail);
        emails.push(contactEmail);
    }

    return emails;
}
